import { type GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import { AutoCheckReport } from '~/contracts/vdp';
import type { VehicleIdParams } from '~/server-props/vdp/contracts';
import getAutoCheckReport from '~/server-props/vdp/getAutoCheckReport';
import getVehicleId from '~/server-props/vdp/utils/getVehicleId';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

type OwnProps = {
  report: AutoCheckReport;
};

export default function AutoCheck({ report }: OwnProps) {
  return (
    <>
      <NextSeo
        title="AutoCheck Report | Carvana"
        description="Used Vehicle AutoCheck Report | Carvana"
      />
      <ErrorBoundary>
        <div dangerouslySetInnerHTML={{ __html: report.head }}></div>
        <div
          className="pb-12 m:pb-20"
          data-qa="inspection-report"
          dangerouslySetInnerHTML={{ __html: report.body }}
        />
      </ErrorBoundary>
    </>
  );
}

export const getServerSideProps = async (
  context: GetServerSidePropsContext<VehicleIdParams>
) => {
  const vehicleId = getVehicleId(context.params ?? {});

  return vehicleId
    ? getAutoCheckReport(context, vehicleId)
    : { notFound: true };
};
